// extracted by mini-css-extract-plugin
module.exports = {"description":"asset_description__1h00U","listItemContainer":"asset_listItemContainer__2c-0Z","name":"asset_name__2DshL"};